export default async ({ route }) => {
  if (process.client && !route.fullPath.startsWith('/landing')) {
    try {
      const { default: Vue } = await import('vue')
      const { default: Quasar } = await import('quasar/dist/quasar.esm')
      Vue.use(Quasar)
    } catch (error) {
      console.error('Error when importing Quasar:', error)
    }
  }
}
